import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const BalanceCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));

export const BalanceOwedGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const BalanceAmount = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
}));

export const TipsHistoryList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const DayContainer = styled(Box)(({ theme }) => ({
  '& + &': {
    marginTop: theme.spacing(1),
  },
}));

export const DayHeader = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
  fontSize: '13px',
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));

export const DayItemsList = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: '12px',
  overflow: 'hidden',
}));

export const TipsHistoryItem = styled(Box)(({ theme, hasData, isLast }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1.75, 2),
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  opacity: hasData ? 1 : 0.5,
}));

export const TipsHistoryItemSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
  fontSize: '13px',
  lineHeight: '18px',
}));

export const IconContainer = styled(Box)({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
});

export const PayoutContentWrapper = styled(Box)({
  flexGrow: 1,
  flexShrink: 1,
  minWidth: 0,
});

export const BalanceText = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
  fontSize: '13px',
  flexShrink: 0,
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4),
}));
